import React from 'react'
import c from 'classnames'
import { connect } from 'react-redux'
import sample from 'lodash/sample'
import shuffle from 'lodash/shuffle'
import Loading from 'discada/dist/Loading'
import { getLastRetry, getActiveRequests } from 'selectors/appStatusSelectors'

import Icon from 'discada/dist/Icon'

import QUOTES from './quotes'

import './LoadingQuote.scss'

const PROGRESS_MAX = 100
// These factors will be used to advance the progress bar according to Zeno's Paradox (with a twist)
// They represent the first part of the infinite series 1/2^n, but the first few have been replaced to add up to 1/2 so that the progress bar doesn't advance too quickly.
// The values in here must conform to the series towards the end, because the function that uses them looks for the smallest value in the series to figure out where it should pick up once these values are exhausted.
const FACTORS = shuffle([
  1 / 20,
  1 / 20,
  2 / 20,
  3 / 20,
  1 / 20,
  2 / 20,
  1 / 4,
  1 / 8,
  1 / 16,
  1 / 32,
])
const SKIP = 4
const MAGIC_FACTOR = Math.log2(1 / Math.min(...FACTORS)) + 1
const REFRESH_OFFSET = MAGIC_FACTOR - FACTORS.length

export class LoadingQuote extends React.Component {
  constructor(...args) {
    super(...args)

    this.state = { progress: 0, refreshCount: 0, quote: sample(QUOTES) }
  }

  static getDerivedStateFromProps(_, oldState) {
    let { progress, refreshCount } = oldState,
      index = Math.floor(refreshCount / SKIP),
      advanceProgress = refreshCount % SKIP === 0, // we only advance the progress bar every SKIP frames
      // either use one of the factors (if not exhausted), or continue the infinite series.
      offset =
        index < FACTORS.length
          ? FACTORS[index]
          : 1 / 2 ** (index + REFRESH_OFFSET),
      nextState = {
        ...oldState,
        refreshCount: refreshCount + 1,
      }

    return advanceProgress
      ? {
          ...nextState,
          quote: sample(QUOTES),
          progress: progress + PROGRESS_MAX * offset,
        }
      : nextState
  }

  render() {
    let { className, hideLoader, showProgressBar } = this.props,
      { progress, quote } = this.state

    return (
      <div className={c('loading-quote', className)}>
        {showProgressBar && (
          <progress
            className="progress is-small"
            value={progress}
            max={PROGRESS_MAX}
          />
        )}
        <div className="loading-quote-quote">
          <Icon icon="quote-left" />
          {quote.quote}
        </div>
        <div className="loading-quote-attribution">{quote.attribution}</div>
        <br />
        {!showProgressBar && !hideLoader && <Loading />}
      </div>
    )
  }
}

function mapStateToProps(state, op) {
  return {
    ...op,
    lastRetry: getLastRetry(state),
    activeRequests: getActiveRequests(state),
  }
}

export default connect(mapStateToProps)(LoadingQuote)
